// library imports
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

// User Component imports
import * as SceneConfig from "_core/configs/SceneConfig";
import * as Constants from "_core/configs/Constants";
import { canCreateTenant } from "_core/utils/common";
import AdminUserEdit from "./parts/AdminUserEdit";
import AdminUserActionLog from "./parts/AdminUserActionLog";
import AdminUserChatLog from "./parts/AdminUserChatLog";
import AdminUserChatReport from "./parts/AdminUserChatReport";
import AdminUserProfileEdit from "./parts/AdminUserProfileEdit";
import AdminUserInquirySetting from "./parts/AdminUserInquirySetting";
import AdminUserInquiryLog from "./parts/AdminUserInquiryLog";
import AdminUserManage from "./parts/AdminUserManage";

import AdminUserRagStructure from "./parts/AdminUserRagStructure";
import AdminUserRagUpload from "./parts/AdminUserRagUpload";
import AdminUserRagPlayground from "./parts/AdminUserRagPlayground";
import AdminUserRagEvaluate from "./parts/AdminUserRagEvaluate";

import AdminOpsPrompt from "./parts/ops/AdminOpsPrompt";
import AdminOpsAppearance from "./parts/ops/AdminOpsAppearance";
import AdminOpsDemoPage from "./parts/ops/AdminOpsDemoPage";
import AdminOpsConfig from "./parts/ops/AdminOpsConfig";
import AdminOpsTenant from "./parts/ops/AdminOpsTenant";

const AdminScene = () => {
    const location = useLocation();
    const { tAccount, tUser } = useSelector((store) => store.transaction);

    // 運営ホームテナントの運営は、使う画面以外（ブックマークや戻る操作で開いた基本情報など）をテナント作成へ移す
    const parts = location.pathname.split("/").pop();
    if (canCreateTenant(tAccount?.auth, tUser) && !SceneConfig.OPS_HOME_PARTS.includes(parts)) {
        return <Navigate to={SceneConfig.PAGES.PARTS_ADMIN_OPS_TENANT} replace />;
    }

    return (
        <div id="Admin" className="scene-parent-root">
            <Routes>
                <Route path={SceneConfig.PARTS_ADMIN_USEREDIT}                   element={<AdminUserEdit />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_ACTION_LOG}            element={<AdminUserActionLog />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_CHATLOG}               element={<AdminUserChatLog />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_CHATREPORT}            element={<AdminUserChatReport />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_PROFILE_EDIT}          element={<AdminUserProfileEdit />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_INQUIRY_SETTING}       element={<AdminUserInquirySetting />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_INQUIRY_LOG}           element={<AdminUserInquiryLog />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_RAG_STRUCTURE}         element={<AdminUserRagStructure />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_RAG_UPLOAD}            element={<AdminUserRagUpload />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_RAG_EVALUATE}          element={<AdminUserRagEvaluate />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_RAG_PLAYGROUND}        element={<AdminUserRagPlayground />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_MANAGE}                element={<AdminUserManage />} />
                <Route path={SceneConfig.PARTS_ADMIN_OPS_PROMPT}                 element={<AdminOpsPrompt />} />
                <Route path={SceneConfig.PARTS_ADMIN_OPS_APPEARANCE}             element={<AdminOpsAppearance />} />
                { Constants.IS_DEMO_PAGE_AVAILABLE &&
                <Route path={SceneConfig.PARTS_ADMIN_OPS_DEMO_PAGE}              element={<AdminOpsDemoPage />} />
                }
                <Route path={SceneConfig.PARTS_ADMIN_OPS_CONFIG}                 element={<AdminOpsConfig />} />
                <Route path={SceneConfig.PARTS_ADMIN_OPS_TENANT}                 element={<AdminOpsTenant />} />
            </Routes>
        </div>
    );
};

export default AdminScene;